<template>
  <div class="lead d-flex align-center justify-center">
    <div class="lead-content d-flex f-column align-center justify-center">
      <h3>我们的优势</h3>
      <p>advantage</p>
      <div class="list d-flex">
        <div class="item d-flex f-column align-center justify-center">
          <el-image
            class="image"
            :src="require('@/assets/images/about_icon_01.png')"
          ></el-image>
          <div class="title">行业优势</div>
          <span class="desc"
            >国家大力扶持，畜牧市场消费空间大、拥有国家生猪大数据中心</span
          >
        </div>
        <div class="item d-flex f-column align-center justify-center">
          <el-image
            class="image"
            :src="require('@/assets/images/about_icon_02.png')"
          ></el-image>
          <div class="title">产品优势</div>
          <span class="desc">品质优良、规模养殖、绿色健康、可持续发展</span>
        </div>
        <div class="item d-flex f-column align-center justify-center">
          <el-image
            class="image"
            :src="require('@/assets/images/about_icon_03.png')"
          ></el-image>
          <div class="title">环境优势</div>
          <span class="desc">水土丰茂、专业的养殖场地、屠宰场地、无害处理中心</span>
        </div>
        <div class="item d-flex f-column align-center justify-center">
          <el-image
            class="image"
            :src="require('@/assets/images/about_icon_04.png')"
          ></el-image>
          <div class="title">技术优势</div>
          <span class="desc">优秀的技术研发团队以及管理层，良好的现代化管理方式</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.lead {
  padding-top: 1.25rem;
  &-content {
    h3 {
      font-size: 0.45rem;
      padding-bottom: 0.375rem;
    }
    p {
      text-transform: uppercase;
      font-size: 0.25rem;
      color: #666;
      margin-bottom: 1rem;
    }
    .list {
      padding-bottom: 1.25rem;
      .item {
        width: 3.5625rem;
        height: 3.25rem;
        background-color: #f9fafe;
        margin-right: 0.25rem;
        &:last-of-type {
          margin-right: 0;
        }
        .image {
          display: block;
          width: 0.625rem;
          height: 0.625rem;
        }
        .title {
          font-weight: 600;
          font-size: 0.25rem;
          color: #666;
          padding: 0.45rem 0 0.3rem;
        }
        .desc {
          padding: 0 0.3rem;
          line-height: 0.3rem;
          text-align: center;
          font-size: 0.175rem;
          color: #999;
        }
      }
    }
  }
}
</style>
